import React, {useEffect, useState} from 'react';
import {TwoColumnLayout} from '../../components';
import individualPackagesProvider from '../../services/individualPackagesProvider';
import {useParams} from 'react-router';
import {IndividualPackageDto} from '../../types/individualPackages';
import UniformPackage from '../../components/individualPackage/UniformPackage/UniformPackage';
import IndividualPackageDetails from '../../components/individualPackage/IndividualPackageDetails/IndividualPackageDetails';
import {Box, createStyles, makeStyles, Theme} from '@material-ui/core';
import TopBarRegular from '../../components/Layout/TopBar/TopBar';
import OwnPackage from '../../components/insurancePackage/OwnPackage/OwnPackage';

const interriskPackageDetails = {
    name: 'Opieka telemedyczna dla klientów InterRisk',
    description: '',
    imageUri: 'https://plvzsadevweu.blob.core.windows.net/common/insurance-package/interrisk_banner.png',
    text: 
        `Skorzystaj z bezpłatnych e‑konsultacji w ramach Twojej umowy ubezpieczenia.
        Wpisz następujące dane w polu „Numer polisy”, w zależności od produktu, który posiadasz:

        <ul style="list-style: none; padding-left: 0;">
            <li style="
                background:url('https://plvzsadevweu.blob.core.windows.net/common/insurance-package/icon1.png')
                no-repeat left top;
                padding-left:32px;
                min-height:24px;
                margin-bottom:8px;">
                <span>
                    EDUOne - serię i numer polisy (np. VEDO-A/S123456)
                </span>
            </li>

            <li style="
                background:url('https://plvzsadevweu.blob.core.windows.net/common/insurance-package/icon1.png')
                no-repeat left top;
                padding-left:32px;
                min-height:24px;
                margin-bottom:8px;">
                <span>
                    EDU Plus – serię i numer polisy (np. EDU-A/P000000, EDUS-A/P000000, EDUD-A/P000000)
                </span>
            </li>

            <li style="
                background:url('https://plvzsadevweu.blob.core.windows.net/common/insurance-package/icon2.png')
                no-repeat left top;
                padding-left:32px;
                min-height:24px;
                margin-bottom:8px;">
                <span>
                    NNW odNOWA – serię i numer polisy (np. NWG-B/P000000, NWI-B/P000000)
                </span>
            </li>

            <li style="
                background:url('https://plvzsadevweu.blob.core.windows.net/common/insurance-package/icon3.png')
                no-repeat left top;
                padding-left:32px;
                min-height:24px;">
                <span>
                    Puls Zdrowia / Puls Pracownika – numer PESEL (np. 11111111111),
                    w przypadku obcokrajowców – numer dokumentu tożsamości, np. paszportu AA0000000
                </span>
            </li>
        </ul>`,
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        [theme.breakpoints.down('sm')]: {
            leftColumnWrapper: {
                padding: 20,
                backgroundColor: 'white',
                marginBottom: 16,
            },
        },
    }),
);
const InterriskInsurancePackagePage = () => {
    const classes = useStyles();


    return (
        <TwoColumnLayout>
            <TwoColumnLayout.Header>
                <TopBarRegular />
            </TwoColumnLayout.Header>
            <TwoColumnLayout.Main>
                <TwoColumnLayout.LeftColumn>
                    <Box className={classes.leftColumnWrapper}>
                        <IndividualPackageDetails
                            name={interriskPackageDetails?.name}
                            description={interriskPackageDetails?.description}
                            imageUri={interriskPackageDetails?.imageUri}
                            text={interriskPackageDetails?.text}
                        />
                    </Box>
                </TwoColumnLayout.LeftColumn>
                <TwoColumnLayout.RightColumn>
                    <OwnPackage/>
                </TwoColumnLayout.RightColumn>
            </TwoColumnLayout.Main>
        </TwoColumnLayout>
    );
};

export default InterriskInsurancePackagePage;
